module.exports = __webpack_public_path__ + "static/img/list_cg.797e003a.png";